<template>
  <div
    class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:gap-x-5"
    :class="columns === 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-2'"
  >
    <WizardField
      v-for="field in shown"
      :key="field.name"
      :form
      :field
      :origin="origins[field.name]"
      :readonly="readonlyFields?.includes(field.name)"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import WizardField from './WizardField.vue'

import { visibleFields } from '../utils/helpers'
import { WizardFieldDef, WizardFieldOrigin } from '../utils/types'

/*
 * A step's fields, laid out. Two columns while working through a step, three on
 * the summary where the cards are wider. A value the flow fixes is not in this
 * grid: it is not the user's to see or change.
 */
const { fields, origins } = defineProps<{
  form: any
  fields: WizardFieldDef[]
  origins: Record<string, WizardFieldOrigin>
  /** Shown as text rather than as controls. Used on the summary only. */
  readonlyFields?: string[]
  columns?: 2 | 3
}>()

const shown = computed(() => visibleFields(fields, origins))

</script>
